import React, {Component} from 'react'
import PropTypes from 'prop-types';

const HtmlTo = (props) => {
    // for the time being assumes that html has only one open and one close tag

    let openTag = `<${props.tag}>`;
    let closeTag = props.before ? `</${props.tag}>` : `<${props.tag}/>`;
    let parts = props.html.split(openTag);

    if (parts.length === 1){
       return <span>{props.html}</span>
    }

    let start = parts[0];
    parts = parts[1].split(closeTag);
    let middle = parts[0];
    let end = parts[1];

    switch (openTag) {
        case '<i>':
             return <span>{start}<i>{middle}</i>{end}</span>
        default:
            console.log(`please implement tag ${openTag} in htmlToReact`);
    }

};


class HtmlToReact extends Component {
    render() {
        return (
            <HtmlTo tag={this.props.tag}
                    before={this.props.before}
                    html={this.props.html}/>
        )
    }

}

HtmlToReact.propTypes = {
    tag: PropTypes.string.isRequired,
    before: PropTypes.bool.isRequired,
    html:PropTypes.string.isRequired,
};


export default HtmlToReact



// WEBPACK FOOTER //
// ./src/html-to-react.jsx